import CryptoJS from 'crypto-js'
// import { mathName, StringArr } from './sign.js'
const StringArr = function () {
  let arr = ['H', 'ma', 'A', '2', 'S', '6', 'M', '5', 'c', 'N', '9']
  return arr
}
const mathName = function () {
  // 只有a，b,c,e,f的值有用
  let obj = {
    l: 'ens0bdj',
    g: 'djgdhb5',
    a: 'sxplG6Hs',
    b: '2biIi1Sh3',
    c: 'cNQN2MQ',
    e: 'KzEg5m',
    f: 'tN',
    k: 'ydjg',
    m: 'owkfj'
  }
  return obj
}

/**
* @description: 签名认证，256加密（wsQ5xxxxwp6前后端保持一致）,返回结果设置USER-SIGN
* @param {String} url 接口名，不需要域名和二级域名
* @param {Object} data 请求参数
* @param {Sting} signKey 签名认证的密钥（前后端一致）
*/
export const sha256Sign = function (url, data, signKey) {
  const hash = CryptoJS.HmacSHA256(`${url}?json=${JSON.stringify(data)}`, signKey)
  const hashInBase64 = CryptoJS.enc.Base64.stringify(hash)
  return hashInBase64
}

// let string = 'sxplG6Hs2biIi1Sh3cNQN2MQKzEg5mtN'
// let string = 'JfIR9RofenbQoTO'
// let hash = CryptoJS.HmacSHA256(`${url}?json=${JSON.stringify(data)}&t=${timestamp}`, 'JfIR9RofenbQoTO')
function random (url, data) {
  // console.log(Object.keys(mathName()))
  let randomMath = Object.keys(mathName())
  const timestamp = new Date().getTime()
  let params = JSON.stringify(data)
  let strings = StringArr()
  let names = mathName()
  let a = `${strings[0]}${strings[1]}${strings[8]}${strings[4]}`
  let signString = `${names[randomMath[2]]}${names[randomMath[3]]}${names[randomMath[4]]}${names[randomMath[5]]}${names[randomMath[6]]}`
  let b = `${strings[0]}${strings[2]}${strings[3]}${strings[7]}${strings[5]}`
  let signName = a + b
  let oneParams = `${url}?json=${params}&t=${timestamp}`
  let twoParams = `${signString}`
  let hash = CryptoJS[signName](oneParams, twoParams)
  let hashInBase64 = CryptoJS.enc.Base64.stringify(hash)
  return hashInBase64 + timestamp
}
export {
  random
}

/**
 * 协议客户加密签名，用于请求头
*/
export const encryptUserSign = (url, params, signKey) => {
  const stringify = `${url}?json=${JSON.stringify(params)}`
  const hash = CryptoJS.HmacSHA256(stringify, signKey)
  return CryptoJS.enc.Base64.stringify(hash)
}
